<template>
	<div
		:class="[
			'c-block-list-form-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<TransitionExt
			name="block-list-form-custom"
			duration="200"
			mode="out-in"
		>
			<UmbracoForm
				:id="form"
				ref="form"
				class="s-umbraco-form"
				:definitions-endpoint="definitionsUrl"
				:post-endpoint="entriesUrl"
			>
				<template #loading>
					<div
						class="w-full flex flex-col justify-center items-center"
						style="height: min(80vh, 400px)"
					>
						<SearchLoader
							class="
								sticky
								top-0
								bottom-0
								mx-auto
								w-md
								text-extra
							"
						/>
					</div>
				</template>

				<template #error="{ error }">
					<BaseH2 class="mb-sm"> Der skete en fejl </BaseH2>
					Fejlbesked: "{{ error.message }}"

					<BaseButton class="mt-md" @click="tryAgain">
						Prøv igen
					</BaseButton>
				</template>

				<template #title="{}"><span></span></template>
			</UmbracoForm>
		</TransitionExt>
	</div>
</template>

<script>
import UmbracoForm from '~/citi-baseline/components/UmbracoForm';
import SearchLoader from '~/components/shared/SearchLoader';

export default {
	name: 'BlockListFormCustom',

	components: {
		UmbracoForm,
		SearchLoader,
	},

	inheritAttrs: false,

	props: {
		renderUrl: String,
		definitionsUrl: String,
		entriesUrl: String,
		form: String,
	},

	methods: {
		tryAgain() {
			this.$refs.form?.fetchFormMarkup?.();
		},
	},
};
</script>

<style lang="postcss">
.t-block-list-form-custom-enter-active,
.t-block-list-form-custom-leave-active {
	@apply transition-opacity ease-smooth-out;
}
.t-block-list-form-custom-enter,
.t-block-list-form-custom-leave-to {
	@apply opacity-0;
}
</style>
